import { apiClient } from "../lib/api-client";
import { ApiResponse, PaginatedResponse } from "../types/api.types";

export interface Notification {
    _id: string;
    userId: string;
    type: string;
    title: string;
    message: string;
    read: boolean;
    data?: any;
    createdAt: string;
}

export const notificationService = {
    async getNotifications(page = 1, limit = 10, read?: boolean): Promise<PaginatedResponse<Notification>> {
        let query = `?page=${page}&limit=${limit}`;
        if (read !== undefined) {
            query += `&read=${read}`;
        }

        const response = await apiClient.get<any>(`/notifications${query}`);

        if (response.success && response.data) {
            return {
                items: response.data.notifications,
                pagination: response.data.pagination
            };
        }
        throw new Error(response.message || "Failed to fetch notifications");
    },

    async getUnreadCount(): Promise<number> {
        const response = await apiClient.get<{ count: number }>("/notifications/unread-count");
        if (response.success && response.data) {
            return response.data.count;
        }
        return 0;
    },

    async markAsRead(id: string): Promise<boolean> {
        const response = await apiClient.patch(`/notifications/${id}/read`);
        return response.success;
    },

    async markAllAsRead(): Promise<boolean> {
        const response = await apiClient.patch("/notifications/read-all");
        return response.success;
    },

    async deleteNotification(id: string): Promise<boolean> {
        const response = await apiClient.delete(`/notifications/${id}`);
        return response.success;
    }
};
